import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState('en');
  useEffect(()=>{
    const savedLanguage=localStorage.getItem('appLanguage');
    if(savedLanguage){
      i18n.changeLanguage(savedLanguage);
      setCurrentLanguage(savedLanguage);
    }else{
      i18n.changeLanguage('en');
      localStorage.setItem('appLanguage','en');
      setCurrentLanguage('en');
    }
  },[]);

  const changeLanguage = (lng) => {
    setCurrentLanguage(lng);
    i18n.changeLanguage(lng);
    localStorage.setItem('appLanguage',lng)
  };

  return (
    <div className="flex items-center gap-2">
      <Globe size={18} className="text-gray-600" />
      <Select value={currentLanguage} onValueChange={changeLanguage}>
        <SelectTrigger className="w-32 h-9" data-testid="language-switcher">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="en">English</SelectItem>
          <SelectItem value="hi">हिंदी</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default LanguageSwitcher;
